import { Constants } from './database.types';

export const LAYER_TYPE = Object.fromEntries(
  Constants.public.Enums.layer_type.map(value => [value.toUpperCase(), value] as const)
) as { [K in (typeof Constants.public.Enums.layer_type)[number] as Uppercase<K>]: K };

export const LAYER_TYPE_VALUES = {
  ALL: Constants.public.Enums.layer_type,
  USER_CREATED: [LAYER_TYPE.STANDARD, LAYER_TYPE.PARCEL],
  SYSTEM: [LAYER_TYPE.TILESET],
  INTEGRATION: [LAYER_TYPE.INTEGRATION_SYNC],
  SITE_DILIGENCE: [LAYER_TYPE.SITE],
  CORE: [LAYER_TYPE.CORE],
} as const;

export const TILESET_FORMAT = Object.fromEntries(
  Constants.public.Enums.tileset_format.map(value => [value.toUpperCase(), value] as const)
) as { [K in (typeof Constants.public.Enums.tileset_format)[number] as Uppercase<K>]: K };

export type UserCreatedLayerTypes = (typeof LAYER_TYPE_VALUES.USER_CREATED)[number];
export type AllLayerType = (typeof LAYER_TYPE_VALUES.ALL)[number];

export const LAYER_STATUS = Object.fromEntries(
  Constants.public.Enums.layer_status.map(value => [value.toUpperCase(), value] as const)
) as { [K in (typeof Constants.public.Enums.layer_status)[number] as Uppercase<K>]: K };

export const LAYER_GEOMETRY_TYPE = Object.fromEntries(
  Constants.public.Enums.layer_geometry_type.map(value => [value.toUpperCase(), value] as const)
) as { [K in (typeof Constants.public.Enums.layer_geometry_type)[number] as Uppercase<K>]: K };

export const JOB_STATUS = Object.fromEntries(
  Constants.public.Enums.job_status.map(value => [value.toUpperCase(), value])
) as { [K in (typeof Constants.public.Enums.job_status)[number] as Uppercase<K>]: K };
